const getExtensionFromUrl = (url = "") => {
  if (typeof url !== "string") return "";
  const finalUrl = url.split("?")[0];
  const parts = finalUrl.split(".");
  return parts[parts.length - 1].toLowerCase();
};

export const PENDING_GALLERY_CREATIVES_KEY = "pendingGalleryCreatives";

export const getGalleryMediaIdentity = (item) => {
  if (
    item?.isCarousel &&
    Array.isArray(item?.carouselImages) &&
    item.carouselImages.length > 0
  ) {
    const urls = item.carouselImages
      .map((image) => (typeof image === "string" ? image : image?.url))
      .filter(Boolean)
      .sort()
      .join("|");
    return urls ? `carousel:${urls}` : "";
  }

  return typeof item?.url === "string" ? item.url : "";
};

export const mergeUniqueMediaUrls = (current = [], incoming = []) => {
  const seen = new Set(
    current.map((item) => getGalleryMediaIdentity(item)).filter(Boolean)
  );
  const merged = [...current];

  incoming.forEach((item) => {
    const identity = getGalleryMediaIdentity(item);
    if (!identity || seen.has(identity)) {
      return;
    }
    seen.add(identity);
    merged.push(item);
  });

  return merged;
};

export const getAcceptedFormatsKey = (acceptedFormats = []) =>
  [...acceptedFormats].sort().join("|");

export const getGalleryHydrationKey = (platformKey, acceptedFormats = []) =>
  `${platformKey}:${getAcceptedFormatsKey(acceptedFormats)}`;

export const mediaListsMatch = (left = [], right = []) => {
  if (left.length !== right.length) {
    return false;
  }

  return left.every(
    (item, index) =>
      getGalleryMediaIdentity(item) === getGalleryMediaIdentity(right[index])
  );
};

export const filterMediaByAcceptedFormats = (
  mediaUrls = [],
  acceptedFormats = [],
  getExtension = getExtensionFromUrl
) => {
  if (!acceptedFormats?.length) {
    return mediaUrls;
  }

  return mediaUrls.filter((mediaUrlData) => {
    if (!mediaUrlData?.url) {
      return false;
    }

    if (
      mediaUrlData?.isCarousel &&
      Array.isArray(mediaUrlData?.carouselImages) &&
      mediaUrlData.carouselImages.length > 1
    ) {
      return mediaUrlData.carouselImages.every((image) => {
        const url = typeof image === "string" ? image : image?.url;
        if (!url) {
          return false;
        }
        return acceptedFormats.includes(getExtension(url));
      });
    }

    return acceptedFormats.includes(getExtension(mediaUrlData.url));
  });
};
